import { render, staticRenderFns } from "./PasswordUpdateForm.vue?vue&type=template&id=ccb2cd94&"
import script from "./PasswordUpdateForm.vue?vue&type=script&lang=ts&"
export * from "./PasswordUpdateForm.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordUpdateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports